export class Messager {
  constructor(profile) {
    this.listeners = [];
    this.alertListeners = [];
    this.rtcListeners = [];
    this.running = false; // Boolean
    this.typingTimer = null; // Timer
    this.profile = profile;
    this.socket = null;
    this.rtc = null;
    this.rtcPartner = null;
    this.rtcListener = null;
    this.reconnecting = false;

    this.sessionDisconnected = false;
    this.missedMessages = [];
  }

  connect() {
    const thisObj = this;

    this.socketConnected = new Promise(function(resolve) {
      if (process.env.NODE_ENV !== "production") {
        resolve(1);
        return;
      }

      if (thisObj.socket) {
        resolve(0);
        return;
      }

      let protocol = window.location.protocol;
      if (protocol === "https:") {
        protocol = "wss:";
      }

      if (protocol === "http:") {
        protocol = "ws:";
      }

      const url = `${protocol}//${window.location.host}/ws`;

      thisObj.socket = new WebSocket(url);

      console.log("Connecting to websocket using URL: " + url);
      thisObj.socket.onopen = function() {
        thisObj.reconnecting = false;
        thisObj.connectionStatus = true;
        thisObj.joinChannel("/notifications/" + thisObj.profile.pseudo);
        resolve(0);
      };

      thisObj.socket.onmessage = function(txt) {
        const msg = JSON.parse(txt.data);

        if (msg.action === "join" && msg.data.message === "succesful") resolve();

        if (msg.action === "send") {
          let i;
          if (msg.data.category === "chatevent") {
            for (i = 0; i < thisObj.listeners.length; i++) {
              thisObj.listeners[i].messageReceived(msg);
            }
          }

          if (msg.data.category === "alert") {
            for (i = 0; i < thisObj.alertListeners.length; i++) {
              thisObj.alertListeners[i].alertReceived(msg);
            }
          }
          resolve();
        }

        if (msg.action == "rtc") {
          for (let listener of thisObj.rtcListeners) {
            listener.messageReceived(msg);
          }
        }

        if (msg.action == "nosession") {
          thisObj.sessionDisconnected = true;
          thisObj.socket.close();
        }
      };

      thisObj.socket.onclose = function() {
        thisObj.connectionStatus = false;
        thisObj.socket = null;
        thisObj.socketConnected = null;

        if (!thisObj.sessionDisconnected) {
          thisObj.reconnecting = true;
          thisObj.attemptReconnect();
          console.log("Socket closed, attempting to reconnect...");
        } else {
          console.log("Socket closed and session is lost");
        }
      };

      thisObj.socket.onerror = function() {
        thisObj.connectionStatus = false;
        thisObj.socket = null;
        resolve(1);
      };
    });
    return this.socketConnected;
  }

  attemptReconnect() {
    const thisObj = this;

    this.reconnectTimer = setInterval(async function() {
      if (!thisObj.socket) {
        const reconnected = await thisObj.connect();

        if (reconnected == 0) {
          clearInterval(thisObj.reconnectTimer);
          thisObj.reconnectTimer = null;
          for (let msg of thisObj.missedMessages) {
            thisObj.sendMessage(msg);
          }
          thisObj.missedMessages = [];
        }
      }
    }, 1000);
  }

  joinChannel(c) {
    const join = {
      channel: c,
      action: "join",
      data: {
        idFrom: this.profile.id
      }
    };
    this.socket.send(JSON.stringify(join));
  }

  sendMessage(msg) {
    if (this.socketConnected && !this.reconnecting) {
      this.socket.send(
        JSON.stringify({
          action: "send",
          channel: "/notifications/" + msg.to.pseudo,
          data: {
            category: "chatevent",
            type: "message",
            idTo: msg.to.id,
            idFrom: msg.from.id,
            message: msg.body
          }
        })
      );
    } else {
      this.missedMessages.push(msg);
    }
  }

  stopTyping(interlocutor) {
    if (this.typingTimer != null) window.clearTimeout(this.typingTimer);
    this.running = false;
    this.sendTyping(interlocutor, "stop");
  }

  startTyping(interlocutor) {
    if (this.running) {
      if (this.typingTimer != null) {
        window.clearTimeout(this.typingTimer);
        this.startTypingTimer(interlocutor);
      }
    } else {
      this.startTypingTimer(interlocutor);
      this.running = true;
      this.sendTyping(interlocutor, "start");
    }
  }

  startTypingTimer(interlocutor) {
    const thisObj = this;
    this.typingTimer = window.setTimeout(function() {
      thisObj.running = false;
      thisObj.sendTyping(interlocutor, "stop");
    }, 500);
  }

  sendTyping(toProfile, type) {
    const thisObj = this;

    this.socket.send(
      JSON.stringify({
        action: "send",
        channel: "/notifications/" + toProfile.pseudo,
        data: {
          category: "chatevent",
          type: "typing",
          idTo: toProfile.id,
          idFrom: thisObj.profile.id,
          message: type
        }
      })
    );
  }

  addListener(listener) {
    this.listeners.push(listener);
  }

  addRtcListener(listener) {
    this.rtcListeners.push(listener);
  }

  addAlertListener(listener) {
    this.alertListeners.push(listener);
  }

  sendJson(obj) {
    this.socket.send(JSON.stringify(obj));
  }
}
